// extracted by mini-css-extract-plugin
module.exports = {"barWrapper":"DiscountsSearchResult__barWrapper___26KNW"};